import { render, staticRenderFns } from "./live-timetable-area.vue?vue&type=template&id=40066504&scoped=true&lang=pug&"
import script from "./live-timetable-area.vue?vue&type=script&lang=js&"
export * from "./live-timetable-area.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40066504",
  null
  
)

export default component.exports